import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { fadeInUp400ms } from '../../../../@vex/animations/fade-in-up.animation';
import { itemService } from '../../../helpers/services/main.service';
import * as moment from "moment";
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { AuthGuardService as AuthGuard } from '../helpers/auth.guard';
import { NotificationsService } from 'angular2-notifications';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'vex-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ]
})
export class LoginComponent implements OnInit {
  emailFormControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  form: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  inputType = 'password';
  visible = false;

  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;

  constructor(private router: Router,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private snackbar: MatSnackBar,
    private itemService: itemService,
    private authGuard: AuthGuard,
    private _service: NotificationsService
  ) {

  }

  async ngOnInit() {
    this.form = this.fb.group({
      email: this.emailFormControl,
      passw: ['', Validators.required],
      remember: [false]
    });
    let form = document.getElementById('form');
    if (localStorage.getItem('token')) {
      let isValid = await this.authGuard.canActivate()
      if (isValid) {
        this.router.navigate(['/apps/dashboards']);
      } else {
        form.style.visibility = 'visible';
      }
    } else {
      form.style.visibility = 'visible';
    }
  }

  async send() {
    if (this.form.value.email && this.form.value.passw) {
      if (this.emailFormControl.valid) {
        console.log(this.form.value)
        await this.itemService.getUserLoginInfo(this.form.value).subscribe((data: any) => {
          if (data) {
            if (data.status == 'success') {
              localStorage.setItem('token', data.token);

              this.router.navigate(['/apps/dashboards']).then(() => {
                this.itemService.getnotifications().subscribe((res: any) => {
                  if (res.status) {
                    res.data.forEach((element, index) => {
                      const notification = this._service[element.type](element.title,
                        element.message,
                        {
                          timeOut: 5000,
                          showProgressBar: true,
                          pauseOnHover: true,
                          clickToClose: true,
                          maxLength: 10
                        })
                      notification.click.subscribe(async (event) => {
                        await this.itemService.markNotificationAsRead({ id: element.id }).subscribe((res: any) => {
                          console.log(res)
                        })

                      });
                    });
                  }
                })
              });

            } else {
              this.snackbar.open('The username or password is incorrect.', 'OK', {
                duration: 5000
              });
            }
          }
        })
      } else {
        this.snackbar.open('The email is not a valid email address.', 'OK', {
          duration: 5000
        });
      }
    } else {
      this.snackbar.open('Please fill all the fields.', 'OK', {
        duration: 5000
      });
    }
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }
}
